<template>
  <!-- TODO: Do responsive btn -->
  <div class="
      justify-content-md-center
      d-flex
      flex-column
      justify-content-between
      h-100
      p-3
    " :style="userData.isAndroid ? '' : 'overflow-y: scroll;'">
    <div class="">
      <!-- Imaage -->
      <div class="row">
        <div class="col-md-4 justify-content-center align-self-center">
          <div class="">
            <div class="row" style="">
              <div class="
                  offset-2
                  col-8
                  offset-md-1
                  col-md-10
                  justify-content-center
                  align-self-center
                ">
                <template>
                  <b-img-lazy center class="image" :src="imgBgNEXT" width="172" height="120" />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Choose -->
      <b-row class="pt-3 mb-2">
        <b-col>
          <span class="text-ktb-bold-16">วิธีการขอ Statement (เลือกอย่างน้อย 1 วิธี)</span>
        </b-col>
      </b-row>
      <!-- Choose option -->
      <b-card v-for="(item, key) in updateType" :key="key" class="border-radius-1rem mb-3"
        :body-class="item.active_flag ? 'p-3' : 'p-3 card-disable'" @click="goTo(item.type, item.active_flag)"
        style="cursor: pointer; line-height: 1.25">
        <b-row>
          <b-col>
            <b-row class="upload-type">
              <b-col class="title" align-self="center">
                <span :style="item.type == 1
                  ? ' line-height: 24px;vertical-align: sub;'
                  : ''
                  ">
                  วิธี {{ key + 1 }} : {{ item.uploads_message }}
                </span>
                <b-img class="ml-1" v-if="item.type == 1" height="24" width="24" :src="icon_recommend"></b-img>
              </b-col>
              <div class="w-100" />
              <template v-if="item.type == 1 && objAcc.length == 0">
                <b-col class="text-ktb-regular-16-grey" align-self="center">
                  {{ item.uploads_desc_message }}</b-col>
              </template>
              <template v-if="item.type == 2 && getSizeUpload() == ''">
                <b-col class="text-ktb-regular-16-grey" align-self="center">
                  {{ item.uploads_desc_message }}</b-col>
              </template>
              <template v-if="item.type == 3 && !dStatementSelected">
                <b-col class="text-ktb-regular-16-grey" align-self="center">
                  {{ item.uploads_desc_message }}</b-col>
              </template>
            </b-row>
          </b-col>
          <b-col cols="auto" align-self="center" style="" class="pl-0">
            <b-img v-if="item.active_flag" width="24" height="24" center style="cursor: pointer"
              :src="imgArrowRight"></b-img>
          </b-col>
        </b-row>
        <b-row v-if="item.type == 1 && objAcc.length > 0">
          <div class="w-100 border-top-NEXT mx-3 mt-3" />
          <b-col class="mt-3">
            <b-row v-for="(item, key) in objAcc" :key="key" class="py-3">
              <b-col cols="auto" align-self="center">
                <!-- style="padding: 0px !important;" -->
                <b-img center height="40" width="40" :src="icon_ktb_bookbank"></b-img>
              </b-col>
              <b-col cols="auto" class="pl-0">
                <span class="text-ktb-bold-16">{{ item.accountName }}</span>
                <div class="w-100" />
                <span class="text-ktb-regular">
                  {{ maskAccountNo(item.accountNo) }}
                </span>
              </b-col>
            </b-row>
          </b-col>
          <div class="w-100  border-top-NEXT mx-3 mt-3" />
          <b-col class="mt-3">
            <b-row>
              <b-col align-self="start" class="text-ktb-regular">รายการบัญชีระหว่างวันที่</b-col>
              <b-col align-self="end" class="text-ktb-bold-16 text-right">{{
                userData.periodStatementKtb
              }}</b-col>
            </b-row>
          </b-col>
          <div class="w-100 border-top-NEXT mx-3 mt-3" />
          <b-col class="mt-3"><span :class="checkDocIsSuccess() ? 'text-upload' : ' text-wait-upload'">{{
            checkDocIsSuccess() ? "จัดส่งเอกสารสำเร็จ" : "รอส่ง Statement"
              }}</span></b-col>
        </b-row>
        <b-row v-if="item.type == 2">
          <template v-if="
            'RESUBMIT' === userData.followupStatus.code &&
            getHistoryUploads() &&
            documentType.state == 'wait'
          ">
            <div class="w-100 border-top-NEXT mx-3 my-3" />
            <div class="w-100" />
            <b-col class="my-3"><span class="text-upload-error">กรุณาอัปโหลดเอกสารใหม่</span></b-col>
          </template>
          <template v-else-if="getSizeUpload() != ''">
            <div class="w-100 border-top-NEXT mx-3 my-3" />
            <div class="w-100" />
            <b-col v-if="documentType.state != 'error'"><span :class="checkDocIsSuccess() ? 'text-upload' : 'text-wait-upload'
              ">{{ getSizeUpload() }}</span></b-col>
            <b-col v-else>
              <span class="text-upload-error">อัปโหลดไม่สำเร็จ {{ documentType.filesReal.length }} ไฟล์
              </span>
            </b-col>

            <b-col v-if="documentType.state == 'attachfile'">
              <span style="float: right" :class="checkDocIsSuccess() ? 'text-upload' : 'text-ktb-bold-16-grey'
                ">{{ getSizeFileUploadsMB(documentType.filesReal) }} MB
              </span></b-col>
          </template>
        </b-row>
        <b-row v-if="item.type == 3 && dStatementSelected && item.active_flag">
          <div class="w-100 border-top-NEXT mx-3 my-3" />
          <b-col><span class="text-ktb-regular-org">รอดำเนินการ dStatement</span></b-col>
          <div class="w-100" />
          <b-col class="mb-2"><span class="text-ktb-regular-16-grey">ระบบจะพาคุณไปขอ dStatement
              หลังจากที่คุณส่งเอกสารอื่นเรียบร้อย</span></b-col>
        </b-row>
        <b-row v-if="item.type == 3 && !item.active_flag && showDstatementMessage()">
          <div class="w-100 border-top-NEXT my-3 mx-3" />
          <b-col style="color: rgb(219, 0, 0)"><span>ไม่สามารถขอ dStatement ได้
              เนื่องจากขอเกินจำนวนที่กำหนดแล้ว</span></b-col>
        </b-row>
      </b-card>
    </div>
    <!-- Button -->
    <div>
      <b-row>
        <b-col align-self="center">
          <button @click="goback()" :disabled="checkRequire()" :class="'btn btn-info rounded-pill btn-block font-weight-bold btn-ktb btn-submit btn-ktb-' +
            userData.channel
            " style="letter-spacing: -1px">
            {{ "เสร็จสิ้น" }}
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    grpId: { type: String, required: true },
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  mounted() {
    if (this.userData.accountSelected != undefined) {
      this.objAcc = this.userData.listAccount.filter((i) =>
        this.userData.accountSelected.includes(i.accountNo)
      );
    }
    if (this.userData.dStatementSelected != null) {
      this.dStatementSelected = this.userData.dStatementSelected;
    }

    this.documentType = this.userData.documentType.find(
      (v) =>
        v.doc_code ==
        this.userData.document_group_type.find(
          (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
        ).lst_doc_id[0]
    );
    this.$store.dispatch("setUserData", this.userData);
  },
  data() {
    return {
      imgBgNEXT: require("@/assets/images/Upload Documents@3x.png"),
      updateType: [],
      objAcc: [],
      icon_recommend: require("@/assets/images/iconRecommendFill.png"),
      icon_ktb_bookbank: require("@/assets/images/BankLogo/KTB.png"),
      imgArrowRight: require("@/assets/images/foundationIconSimpleSystemArrowRight@3x.png"),
      dStatementSelected: false,
      uploaded: null,
      documentType: {},
    };
  },
  created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    let currentMenu = {
      pageCode: "CommonStatementDocument",
      pageName: this.userData.document_group_type.find(
        (i) => i.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      ).grp_name,
      previousPage: this.userData.routerPath.landing,
    };
    this.$event.$emit("update_current_menu", currentMenu);
    this.initUpdateType();
  },
  methods: {
    initUpdateType() {
      this.updateType = [];
      this.updateType.push({
        type: 1,
        uploads_message: "Statement จากบัญชีกรุงไทย",
        uploads_desc_message: "สะดวก รวดเร็ว ไม่ต้องอัปโหลดเอกสาร",
        active_flag: this.userData.haveListAccount,
      });
      this.updateType.push({
        type: 2,
        uploads_message: "อัปโหลด Statement ด้วยตนเอง",
        uploads_desc_message: "รองรับเอกสาร PDF และ รูปถ่าย",
        active_flag: true,
      });
      this.updateType.push({
        type: 3,
        uploads_message: "ขอ Statement  จากธนาคารอื่น(dStatement)",
        uploads_desc_message: "บริการขอ Statement ในรูปแบบดิจิทัล",
        active_flag: this.userData.showDStatement,
      });
    },

    goback() {
      this.$router.push({
        name: this.userData.routerPath.landing,
      });
    },
    goTo(type, flag) {
      if (!flag) return;
      if (1 === type) {
        this.$router.push({
          name: this.userData.routerPath.listAccount,
          param: {
            checkDocIsSuccess: this.checkDocIsSuccess(),
          },
        });
      } else if (2 === type) {
        let document_group_type = this.userData.document_group_type.find(
          (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
        );
        this.$router.push({
          name: this.userData.routerPath.upload,
          params: {
            doc_code: document_group_type.lst_doc_id[0],
            grpId: this.grpId,
          },
        });
      } else if (3 === type) {
        this.$router.push({
          name: this.userData.routerPath.dStatement,
          param: {
            checkDocIsSuccess: this.checkDocIsSuccess(),
          },
        });
      }
    },
    maskAccountNo(value) {
      return (
        "XXX" +
        "-" +
        "X" +
        "-XX" +
        value.substring(6, 9) +
        "-" +
        value.substring(9, 10)
      );
    },
    checkDocIsSuccess() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let docType = this.userData.documentType.find(
        (v) => v.doc_code == docCode
      );
      return docType.state != undefined && docType.state == "success";
    },
    getSizeUpload() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let sizeDoc = this.userData.documentType.find(
        (v) => v.doc_code == docCode
      ).filesReal?.length;
      if (sizeDoc > 0) {
        if (this.checkDocIsSuccess()) {
          return "อัปโหลดสำเร็จ " + sizeDoc + " ไฟล์";
        } else {
          return "รออัปโหลด " + sizeDoc + " ไฟล์";
        }
      }
      return "";
    },
    checkRequire() {
      if (this.checkDocIsSuccess()) return false;
      let check = true;
      let type = this.updateType.filter((item) => item.active_flag);
      for (let item of type) {
        if (
          (item.type == 1 && this.objAcc.length > 0) ||
          (item.type == 2 && this.getSizeUpload() != "") ||
          (item.type == 3 && this.dStatementSelected)
        ) {
          check = false;
          break;
        }
      }
      return check;
    },
    getHistoryUploads() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let history = this.userData.historyUploads.find(
        (i) => i.doc_code == docCode
      );
      return history.doc_upload_date !== null;
    },
    getSizeFileUploadsMB(realFiles) {
      let bytes = 0;
      realFiles.forEach((i) => {
        bytes = bytes + i.filesize;
      });
      return (bytes / (1024 * 1024)).toFixed(1);
    },
    showDstatementMessage() {
      return this.userData.showDStatementErrorMsg;
    },
    calMarginTop() {
      var h = window.innerHeight;
      let defaultVal = 27;
      if (h < 800) defaultVal = defaultVal - 25;
      if (this.dStatementSelected) {
        defaultVal = defaultVal - 9;
      }
      if (this.getSizeUpload() != "") {
        defaultVal = defaultVal - 2;
      }
      if (this.objAcc.length != 0) {
        defaultVal = defaultVal - 10 * this.objAcc.length;
      }
      if (defaultVal < 0) return 0;
      return defaultVal;
    },
  },
};
</script>

<style scoped>
.upload-type>.title {
  color: #000000;
}

.upload-type>.footer>button {
  color: #00a3e4;
  background-color: white;
  border-color: #00a3e4;
  font-size: 0.75rem;
}

.upload-type>.body,
.text-grey {
  color: #8e94a4;
}

.text-wait-upload {
  color: rgb(236, 146, 14);
}

.text-upload {
  color: rgb(99, 190, 0);
}

.text-upload-error {
  color: rgb(219, 0, 0);
}

.card-disable {
  color: rgb(138, 159, 171) !important;
  cursor: not-allowed !important;
  background-color: rgb(234, 240, 245) !important;
  border-radius: 15px !important;
}
</style>
